import { fromJS } from 'immutable';


export const PAYPAL_PAYMENT_TYPE = 'paypal';


export const paypalAuthPaymentSerializer = (authData) => {
    const addressLessPayPal = fromJS({
        paymentMethod: PAYPAL_PAYMENT_TYPE,
        
        
        orderID: authData.id,
        response: authData.status,
        firstName: authData.payer.name.given_name,
        lastName: authData.payer.name.surname,
        senderEmail: authData.payer.email_address,
        payerID: authData.payer.payer_id,
        countryCode: authData.payer.address.country_code,
        approved: authData.status === 'COMPLETED'
    });
    if (authData.purchase_units[0].shipping.address) {
        return addressLessPayPal.merge(fromJS({
            city: authData.purchase_units[0].shipping.address.admin_area_2,
            street1: authData.purchase_units[0].shipping.address.address_line_1,
            state: authData.purchase_units[0].shipping.address.admin_area_1,
            postalCode: authData.purchase_units[0].shipping.address.postal_code
        }));
    }
    return addressLessPayPal;
};



export const paypalPaymentDataHandler = authExecutor => (
    Promise.resolve(authExecutor()).then(data => (paypalAuthPaymentSerializer(data)))
);
